(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["rituel-deneyimi"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ritual-guide')) {
    customElements.define('ritual-guide', class extends HTMLElement {
      connectedCallback() {
        this.tabs = Array.from(this.querySelectorAll('[data-ritual-tab]'));
        this.panels = Array.from(this.querySelectorAll('[data-ritual-panel]'));
        this.hint = this.querySelector('[data-ritual-hint]');
        this.tabs.forEach((tab, index) => {
          tab.addEventListener('click', () => this.select(tab.dataset.ritualTab, true));
          tab.addEventListener('keydown', event => this.onKeydown(event, index));
        });
        const defaultMode = this.dataset.defaultMode;
        if (defaultMode && defaultMode !== 'none') this.select(defaultMode, false);
      }

      onKeydown(event, index) {
        if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault();
        let nextIndex = index;
        if (event.key === 'ArrowLeft') nextIndex = (index - 1 + this.tabs.length) % this.tabs.length;
        if (event.key === 'ArrowRight') nextIndex = (index + 1) % this.tabs.length;
        if (event.key === 'Home') nextIndex = 0;
        if (event.key === 'End') nextIndex = this.tabs.length - 1;
        this.tabs[nextIndex].focus();
        this.select(this.tabs[nextIndex].dataset.ritualTab, false);
      }

      select(mode, shouldScroll) {
        this.tabs.forEach(tab => {
          const selected = tab.dataset.ritualTab === mode;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
        });
        this.panels.forEach(panel => {
          const selected = panel.dataset.ritualPanel === mode;
          panel.hidden = !selected;
          if (selected) {
            const iframe = panel.querySelector('[data-spotify-src]');
            if (iframe && !iframe.src.includes('open.spotify.com')) iframe.src = iframe.dataset.spotifySrc;
          }
        });
        if (this.hint) this.hint.hidden = true;
        this.dataset.activeMode = mode;
        if (shouldScroll) {
          const panel = this.querySelector(`[data-ritual-panel="${mode}"]`);
          panel?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        }
        window.Shopify?.analytics?.publish?.('ritual_mode_selected', { mode });
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
